import React, { Component } from "react";
import Icon from "../Common/Icon";
import connect from "react-redux/es/connect/connect";
import { getIsRequiredFlexLoading } from "../../utils/flexRules";
import purifyHTML from "../../utils/purifyHTML";

class Price extends Component {
  render() {
    const {
      type,
      buyProductButtonText = "Kopen",
      productOptionsText = "",
      thisTripCostsText = "",
      buyProductButtonUrl = "",
      price = "",
    } = this.props;

    if (!buyProductButtonUrl) return null;

    let className = "";
    let iconName = "";
    if (type === "e-ticket") {
      className = "container--accent1-tint5";
      iconName = "barcode";
    } else if (type === "ov-chipkaart") {
      iconName = "ov-chip";
    }

    return (
      <div className={`container ${className}`}>
        <div className="container container--center container--clearfix">
          <div className="container container--margin">
            <div className="reisadvies-price__header">
              <div className="reisadvies-price__price-header">
                {iconName ? (
                  <Icon
                    iconName={iconName}
                    title={thisTripCostsText}
                    className="reisadvies-price__icon"
                  />
                ) : null}
                {thisTripCostsText ? (
                  <span
                    className="reisadvies-price__text"
                    dangerouslySetInnerHTML={purifyHTML(thisTripCostsText)}
                  />
                ) : null}
                {price ? (
                  <span className="reisadvies-price__price">{price}</span>
                ) : null}
              </div>
              <div className="reisadvies-price__button-wrapper">
                <span className="reisadvies-price__notice">
                  {productOptionsText}
                </span>
                <a
                  href={buyProductButtonUrl}
                  className="btn reisadvies-price__buy-btn btn--no-margin"
                >
                  {buyProductButtonText}{" "}
                  <Icon
                    className="btn__icon btn__icon--right"
                    iconName="arrow-right"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const eTicketAvailable = (agencyIds = "", plan) => {
  if (!plan || !plan.legs) return false;

  return (
    plan.legs.some(({ mode }) => mode === "BUS") &&
    plan.legs.every(({ mode, agencyId }) => {
      if (mode === "WALK") {
        return true;
      } else if (mode === "BUS") {
        return agencyIds.split(";").includes(agencyId);
      }
      return false;
    })
  );
};

class ReisadviesPrices extends Component {
  render() {
    const { config = [], fare, plan, loading } = this.props;
    return config.map((config) => {
      if (config.type === "ov-chipkaart") {
        if (loading || !fare) {
          return null;
        }
        let price = fare.price.toFixed(2).toString(),
          currencySymbol;
        if (fare.currency === "EUR") {
          currencySymbol = "€";
          price = price.replace(".", ",");
        }
        if (fare.currency === "USD") {
          currencySymbol = "$";
        }
        config.price = `${currencySymbol}${price}*`;
        return <Price key={JSON.stringify(config)} {...config} />;
      } else if (config.type === "e-ticket") {
        if (loading || !eTicketAvailable(config.agencyIds, plan)) {
          return null;
        }
        return <Price key={JSON.stringify(config)} {...config} />;
      }
    });
  }
}

export default connect((state) => {
  const { plans, selectedIndex, isTexelhopperFlexAvailable, loading } =
    state.reisadviezen;
  const plan =
    !isTexelhopperFlexAvailable && plans && selectedIndex !== -1
      ? plans[selectedIndex]
      : null;

  const fare = plan ? plan.fare : null;

  return {
    plan,
    fare,
    loading: loading || getIsRequiredFlexLoading(state),
  };
}, {})(ReisadviesPrices);



// WEBPACK FOOTER //
// ./src/components/Reisadviezen/Prices.js